import { StylesParser } from '../StylesParser'
import { ComponentBuilder } from './ComponentBuilder'
import { ClassesBuilder } from "./ClassesBuilder";

export class ColumnBuilder {
  constructor(column) {
    this.column = column
  }

  build() {
    this.columnClasses = this.getColumnClasses()
    window.StylesBuilder.add(this.getColumnStyles())
    this.id = this.column.id
    this.components = this.column.components.map(component => `${(new ComponentBuilder(component)).build()}`).join('')
    return this.buildHtml()
  }

  getColumnClasses() {
    return new Object({
      classes: (new ClassesBuilder(this.column.classes)).parseClasses().join(' '),
      containerClasses: (new ClassesBuilder(this.column.containerClasses)).parseClasses().join(' '),
    })
  }

  getColumnStyles() {
    return new Object({
      id: this.column.id,
      styles: {
        desktop: (new StylesParser(this.column.styles, 'desktop')).parse(),
        tablet: (new StylesParser(this.column.styles, 'tablet')).parse(),
        phone: (new StylesParser(this.column.styles, 'phone')).parse()
      }
    })
  }

  buildHtml() {
    return `<div class="${this.columnClasses.containerClasses}">
      <div class="${this.columnClasses.classes}">
        ${this.components}
      </div>
    </div>`
  }
}
